// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"59216250","212":"07560268","339":"85972d2e","625":"43df4d5c"}[chunkId] + ".chunk.css";
};